import { useAppDispatch, useAppSelector  } from '../app/hooks';
import { removeFromStorage } from '../features/storageSlice';

import { FilterStorageVersion } from '../filtering';

interface StorageEditedObj {
  editedId: string|undefined,
  isNew: boolean,
  isDelete: boolean,
  refreshAll: boolean,
  queryOpType: string|undefined,
}


/**
 * Get edited id of saved entity for the list screen
 *
 */
export default function useGetEditedId() {
  const storage = useAppSelector(x => x.storage);

  const dispatch = useAppDispatch();

  function getSavedEntity():StorageEditedObj {
    let editedId: string|undefined = undefined;
    let isNew: boolean = false;
    let isDelete: boolean = false;
    let refreshAll: boolean = false;
    let queryOpType: string|undefined = undefined;

    const storageKey = `editedId-${FilterStorageVersion}-${window.location.pathname}${window.location.search}`;

    if (storage[storageKey]) {
      const editedObj = storage[storageKey] as StorageEditedObj;
      editedId = editedObj?.editedId ?? undefined;
      isNew = editedObj?.isNew ?? false;
      isDelete = editedObj?.isDelete ?? false;
      refreshAll = editedObj?.refreshAll ?? false;
      queryOpType = editedObj?.queryOpType ?? undefined;

      dispatch(removeFromStorage(storageKey));
    }

    return {
      editedId,
      isNew,
      isDelete,
      refreshAll,
      queryOpType
    };
  }

  return getSavedEntity;
}
